import React from "react";
import { Section, Reveal, Icon } from "../components/primitives.jsx";
import { IconTile, CTABand } from "../components/blocks.jsx";
import { PageHero, HeroArt } from "../components/visuals.jsx";

export function Services({ go, c, radius = 16 }) {
  const t = c.servicesPage;
  return (
    <main style={{ fontFamily: "var(--font-sans)" }}>
      <PageHero eyebrow={t.eyebrow} title={t.title} lede={t.lede} radius={radius} art={<HeroArt kind="services" radius={radius} />} />

      <Section tone="wash">
        <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-5)" }}>
          {t.detail.map((s, i) => (
            <Reveal key={i} delay={(i % 2) * 60}>
              <div className="rw-svc-row" style={{ display: "grid", gridTemplateColumns: "auto 1fr 1.1fr", gap: "var(--space-7)", alignItems: "start", background: "var(--surface-card)", borderRadius: radius, padding: "var(--space-7)", border: "1px solid var(--border-subtle)", boxShadow: "var(--shadow-sm)" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  <IconTile name={s.icon} tone={i % 2 === 0 ? "red" : "ink"} radius={Math.max(8, radius - 2)} size={60} />
                  <span style={{ fontFamily: "var(--font-mono)", fontSize: 13, fontWeight: 700, color: "var(--neutral-300)" }}>{String(i + 1).padStart(2, "0")}</span>
                </div>
                <div>
                  <span style={{ fontSize: "var(--text-2xs)", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--brand-red)" }}>{s.category}</span>
                  <h2 style={{ margin: "8px 0 0", fontSize: "var(--text-xl)", fontWeight: 800, letterSpacing: "-0.02em", color: "var(--brand-ink)", lineHeight: 1.15 }}>{s.title}</h2>
                  <p style={{ margin: "12px 0 0", fontSize: "var(--text-md)", lineHeight: 1.6, color: "var(--text-body)", maxWidth: 420 }}>{s.body}</p>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, alignSelf: "center" }}>
                  {s.points.map((p) => (
                    <div key={p} style={{ display: "flex", alignItems: "flex-start", gap: 9, fontSize: "var(--text-sm)", color: "var(--text-body)", fontWeight: 500 }}>
                      <Icon name="check" size={17} color="var(--brand-red)" strokeWidth={2.4} style={{ marginTop: 1, flexShrink: 0 }} />
                      <span>{p}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <CTABand title={t.ctaTitle} lede={t.ctaLede} button={t.ctaButton} onClick={() => go("contact")} radius={radius} />
    </main>
  );
}
